import type { ScreenSchema } from './types';

// The unit title text comes from the injected `pageTitle` (the page/unit title string)
// rather than screen-level YAML fields. managesOwnSectionAudio: true suppresses
// uc-screen's generic watcher; the template's own sectionActive watcher calls
// playSlot('intro', pageTitle) with the overrideText instead.
const unitTitleSchema: ScreenSchema = {
  template: ['unit-title', 'subunit-title'],
  managesOwnSectionAudio: true,
  slots: {}
};

export default unitTitleSchema;
